export const socialMediaLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61563119281020',
    youtube: 'https://www.youtube.com/@enduroconnaction-radusa',
    instagram: 'https://www.instagram.com/enduro_connection_radusa/',
    tiktok: 'https://www.tiktok.com/@enduryqgs7r',
} as const;
